"use client";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import FormForm from "./FormForm";
import FormSuccessMessage from "./FormSuccessMessage";
import FormErrorMessage from "./FormErrorMessage";
const FormWrapper = /*#__PURE__*/ React.forwardRef(function FormWrapper(_param, ref) {
    var { className = "", state: initialState = "normal", onSubmit, children } = _param, props = _object_without_properties(_param, [
        "className",
        "state",
        "onSubmit",
        "children"
    ]);
    var _children_find;
    const [state, setState] = React.useState(initialState);
    var _children_find_props_dataname;
    const formName = (_children_find_props_dataname = ((_children_find = children.find((c)=>c.type === FormForm)) === null || _children_find === void 0 ? void 0 : _children_find.props)["data-name"]) !== null && _children_find_props_dataname !== void 0 ? _children_find_props_dataname : "Form";
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-form"
    }, props), {
        ref
    }), React.Children.map(children, (child)=>{
        if (child.type === FormForm) {
            const style = {};
            if (state === "success") {
                style.display = "none";
            }
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                style,
                onSubmit: function() {
                    var _ref = _async_to_generator(function*(e) {
                        try {
                            var _window_grecaptcha;
                            e.preventDefault();
                            if (window.grecaptcha && !((_window_grecaptcha = window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : _window_grecaptcha.getResponse())) {
                                alert(`Please confirm you're not a robot.`);
                                return;
                            }
                            if (onSubmit) {
                                yield onSubmit(e);
                            }
                            setState("success");
                        } catch (err) {
                            setState("error");
                            throw err;
                        }
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                "aria-label": formName
            }));
        }
        if (child.type === FormSuccessMessage) {
            const style = {};
            if (state === "success") {
                style.display = "block";
            }
            if (state === "error") {
                style.display = "none";
            }
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                style,
                tabIndex: -1,
                role: "region",
                "aria-label": `${formName} success`
            }));
        }
        if (child.type === FormErrorMessage) {
            const style = {};
            if (state === "success") {
                style.display = "none";
            }
            if (state === "error") {
                style.display = "block";
            }
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                tabIndex: -1,
                role: "region",
                "aria-label": `${formName} failure`,
                style
            }));
        }
        return child;
    }));
});
export default FormWrapper;
